const phrases = [
  "Fully customizable",
  "Tailored to your workflow",
  "Built around your operations",
  "AI-powered automation",
  "Adapts to your business",
  "Custom modules & dashboards",
];

export default function Marquee() {
  const items = [...phrases, ...phrases, ...phrases];
  return (
    <section
      data-testid="marquee-section"
      className="bg-[#050505] text-white border-y border-white/10 py-6 overflow-hidden"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((p, i) => (
          <div key={i} className="flex items-center gap-12 mx-6 text-base md:text-lg font-light">
            <span className="text-white/80">{p}</span>
            <span className="text-white/30">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
